import 'react-toastify/dist/ReactToastify.css'

import { ThemeProvider } from '@mui/material'
import { useEffect, useState } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { ToastContainer } from 'react-toastify'

import { AppSkeleton } from '@/components'
import { getSessionContext } from '@/endpoints'
import { useApiRequest } from '@/endpoints/hooks'
import { useAppDispatch } from '@/hooks'
import { setToken, setUser } from '@/store/modules/auth/actions'
import { setSessionContext } from '@/store/modules/user/actions'
import { GlobalStyle } from '@/styles/global'
import theme from '@/styles/theme'

import { AppRouter } from './AppRouter'
import { ApiErrorMessage } from './components/ApiErrorMessage'
import { ConfirmationServiceProvider } from './components/ConfirmationService'
import { ErrorContainer } from './components/ErrorContainer'
import { AppContainer } from './styles'
import { AppProps } from './types'

export const App = ({ token }: AppProps) => {
	const dispatch = useAppDispatch()
	const [isSessionContextLoaded, setIsSessionContextLoaded] = useState(false)
	const request = useApiRequest()

	useEffect(() => {
		const updateToken = async () => {
			if (token) {
				dispatch(setToken(token))

				if (!isSessionContextLoaded) {
					const value = await request(getSessionContext())
					if (value.data) {
						value.data.user && dispatch(setUser(value.data.user))
						dispatch(setSessionContext(value.data))
					}
					setIsSessionContextLoaded(true)
				}
			}
		}

		updateToken()
	}, [dispatch, isSessionContextLoaded, request, token])

	return (
		<ThemeProvider theme={theme}>
			<ToastContainer position="bottom-right" className="" />

			<AppContainer>
				<GlobalStyle />
				<ErrorContainer>
					<ConfirmationServiceProvider>
						<DndProvider backend={HTML5Backend}>
							<ApiErrorMessage />
							{!token ? null : isSessionContextLoaded ? (
								<AppRouter />
							) : (
								<AppSkeleton />
							)}
						</DndProvider>
					</ConfirmationServiceProvider>
				</ErrorContainer>
			</AppContainer>
		</ThemeProvider>
	)
}
